import greetings from './pt/greetings'
import legacy from './pt/legacy'
import recordings from './pt/recordings'

const locale = {
  translation: {
    ...greetings,
    ...legacy,
    ...recordings,
  },
}

export default locale
